<template>
    <div v-if="content">
        <span v-html="paperStyle"></span>
        <section class="paper">
            <div class="header">
                <h1>ใบตรวจสภาพรถ</h1>
                <div class="issue">
                    <div>วันที่ {{ $AppUtility.displayOnlyDate(content.data.openDate) }}</div>
                </div>
            </div>

            <div class="document-data">
                <div class="left">
                    <div class="text-strong">ร้านค้าผู้ให้บริการ</div>
                    <div>{{ content.store.info.name }}</div>
                    <div>เลขประจำตัวผู้เสียภาษี {{ content.store.info.taxId }}</div>
                    <div>{{ [ content.store.info.address, content.store.info.subDistrict, content.store.info.district, content.store.info.province, content.store.info.postCode ].join(' ') }}</div>
                    <div>เบอร์โทร {{ content.store.info.tel }}</div>
                </div>
                <div class="right">
                    <div class="text-strong">รายละเอียดลูกค้า</div>
                    <div>{{ getCustomerName() }}</div>
                    <div>เบอร์ติดต่อ {{ getTelData() }}</div>
                    <div>ข้อมูลรถ {{ getLicensePlateData() }}</div>
                    <div>{{ getCarData() }}</div>
                </div>
            </div>

            <div class="bill-no">เลขที่ {{ content.data.number }}</div>

            <table cellpadding="0" cellspacing="0">
                <tr>
                    <th width="16%" class="text-center"></th>
                    <th width="21%" class="text-center">หน้าซ้าย</th>
                    <th width="21%" class="text-center">หน้าขวา</th>
                    <th width="21%" class="text-center">หลังซ้าย</th>
                    <th width="21%" class="text-center">หลังขวา</th>
                </tr>
                <tr>
                    <th colspan="5" class="text-center "><strong>ยางรถยนต์</strong></th>
                </tr>
                <tr>
                    <td>ขนาดยาง</td>
                    <td>{{ content.data.tireFrontLeft.size }}</td>
                    <td>{{ content.data.tireFrontRight.size }}</td>
                    <td>{{ content.data.tireBackLeft.size }}</td>
                    <td>{{ content.data.tireBackRight.size }}</td>
                </tr>
                <tr class="line">
                    <td>ความลึกดอกยาง</td>
                    <td>
                        {{ content.data.tireFrontLeft.worn }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireFrontLeft.belowStandard }">x</span></span>
                            <label>ต่ำกว่ามาตรฐาน</label>
                        </div>
                    </td>
                    <td>
                        {{ content.data.tireFrontRight.worn }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireFrontRight.belowStandard }">x</span></span>
                            <label>ต่ำกว่ามาตรฐาน</label>
                        </div>
                    </td>
                    <td>
                        {{ content.data.tireBackLeft.worn }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireBackLeft.belowStandard }">x</span></span>
                            <label>ต่ำกว่ามาตรฐาน</label>
                        </div>
                    </td>
                    <td>
                        {{ content.data.tireBackRight.worn }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireBackRight.belowStandard }">x</span></span>
                            <label>ต่ำกว่ามาตรฐาน</label>
                        </div>
                    </td>
                </tr>
                <tr class="line">
                    <td>สภาพเนื้อยาง</td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireFrontLeft.tireStatus.checkGroup.statusNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireFrontLeft.tireStatus.checkGroup.statusProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireFrontRight.tireStatus.checkGroup.statusNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireFrontRight.tireStatus.checkGroup.statusProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireBackLeft.tireStatus.checkGroup.statusNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireBackLeft.tireStatus.checkGroup.statusProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireBackRight.tireStatus.checkGroup.statusNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.tireBackRight.tireStatus.checkGroup.statusProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th colspan="5" class="text-center"><strong>เบรก</strong></th>
                </tr>
                <tr>
                    <td>ความหนาเนื้อผ้าเบรก</td>
                    <td>
                        {{ content.data.brakeFrontLeft.brakePadSize }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontLeft.brakePadChangeSuggest }">x</span></span>
                            <label>แนะนำเปลี่ยน</label>
                        </div>
                    </td>
                    <td>
                        {{ content.data.tireFrontRight.brakePadSize }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontRight.brakePadChangeSuggest }">x</span></span>
                            <label>แนะนำเปลี่ยน</label>
                        </div>
                    </td>
                    <td>
                        {{ content.data.brakeFrontLeft.brakePadSize }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontLeft.brakePadChangeSuggest }">x</span></span>
                            <label>แนะนำเปลี่ยน</label>
                        </div>
                    </td>
                    <td>
                        {{ content.data.brakeBackRight.brakePadSize }} มม. 
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackRight.brakePadChangeSuggest }">x</span></span>
                            <label>แนะนำเปลี่ยน</label>
                        </div>
                    </td>
                </tr>
                <tr class="line">
                    <td>สภาพเนื้อผ้าเบรก</td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontLeft.brakePad.checkGroup.brakePadNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontLeft.brakePad.checkGroup.brakePadProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontRight.brakePad.checkGroup.brakePadNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontRight.brakePad.checkGroup.brakePadProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackLeft.brakePad.checkGroup.brakePadNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackLeft.brakePad.checkGroup.brakePadProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackRight.brakePad.checkGroup.brakePadNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackRight.brakePad.checkGroup.brakePadProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                </tr>
                <tr class="line">
                    <td>จานเบรก</td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontLeft.brakeDisc.checkGroup.brakeDiscNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontLeft.brakeDisc.checkGroup.brakeDiscProblem }">x</span></span>
                            <label>มีรอย</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontLeft.brakeDisc.checkGroup.brakeDiscThin }">x</span></span>
                            <label>บาง</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontRight.brakeDisc.checkGroup.brakeDiscNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontRight.brakeDisc.checkGroup.brakeDiscProblem }">x</span></span>
                            <label>มีรอย</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeFrontRight.brakeDisc.checkGroup.brakeDiscThin }">x</span></span>
                            <label>บาง</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackLeft.brakeDisc.checkGroup.brakeDiscNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackLeft.brakeDisc.checkGroup.brakeDiscProblem }">x</span></span>
                            <label>มีรอย</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackLeft.brakeDisc.checkGroup.brakeDiscThin }">x</span></span>
                            <label>บาง</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackRight.brakeDisc.checkGroup.brakeDiscNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackRight.brakeDisc.checkGroup.brakeDiscProblem }">x</span></span>
                            <label>มีรอย</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.brakeBackRight.brakeDisc.checkGroup.brakeDiscThin }">x</span></span>
                            <label>บาง</label>
                        </div>
                    </td>
                </tr>
                <tr class="line">
                    <td>โช้คอัพ</td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberFrontLeft.absorberStatus.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberFrontLeft.absorberStatus.checkGroup.leak }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberFrontLeft.absorberStatus.checkGroup.degenerate }">x</span></span>
                            <label>เสื่อมสภาพ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberFrontRight.absorberStatus.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberFrontRight.absorberStatus.checkGroup.leak }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberFrontRight.absorberStatus.checkGroup.degenerate }">x</span></span>
                            <label>เสื่อมสภาพ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberBackLeft.absorberStatus.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberBackLeft.absorberStatus.checkGroup.leak }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberBackLeft.absorberStatus.checkGroup.degenerate }">x</span></span>
                            <label>เสื่อมสภาพ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberBackRight.absorberStatus.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberBackRight.absorberStatus.checkGroup.leak }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberBackRight.absorberStatus.checkGroup.degenerate }">x</span></span>
                            <label>เสื่อมสภาพ</label>
                        </div>
                    </td>
                </tr>
                <tr class="line">
                    <td>อุปกรณ์โช้คอัพ</td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentFrontLeft.absorberEquipment.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentFrontLeft.absorberEquipment.checkGroup.problem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentFrontRight.absorberEquipment.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentFrontRight.absorberEquipment.checkGroup.problem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentBackLeft.absorberEquipment.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentBackLeft.absorberEquipment.checkGroup.problem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentBackRight.absorberEquipment.checkGroup.normal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.absorberEquipmentBackRight.absorberEquipment.checkGroup.problem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th class="text-center">แบตเตอรี่</th>
                    <th class="text-center">ประเภท</th>
                    <th class="text-center">ตำแหน่งขั้ว</th>
                    <th class="text-center">แรงดันไฟฟ้า</th>
                    <th class="text-center">ค่า CCA</th>
                </tr>
                <tr>
                    <td>รุ่น {{ content.data.battery.name }}</td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.type.checkGroup.typeSMF }">x</span></span>
                            <label>เติมน้ำกลั่น</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.type.checkGroup.typeMF }">x</span></span>
                            <label>MF</label>
                        </div>
                    </td>
                    <td>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.position.checkGroup.positionL }">x</span></span>
                            <label>L</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.position.checkGroup.positionR }">x</span></span>
                            <label>R</label>
                        </div>
                    </td>
                    <td>
                        แรงดันไฟฟ้า {{ content.data.battery.power ? content.data.battery.power : '........' }} v.
                        <br />
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.powerStatus.checkGroup.powerNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.powerStatus.checkGroup.powerProblem }">x</span></span>
                            <label>ผิดปกติ</label>
                        </div>
                    </td>
                    <td>
                        ค่า CCA {{ content.data.battery.cca ? content.data.battery.cca : '........' }}
                        <br />
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.ccaStatus.checkGroup.ccaNormal }">x</span></span>
                            <label>ปกติ</label>
                        </div>
                        <div class="checkbox-group">
                            <span class="checkbox"><span :class="{ 'checked': content.data.battery.ccaStatus.checkGroup.ccaBelowStandard }">x</span></span>
                            <label>ต่ำกว่ามาตราฐาน</label>
                        </div>
                    </td>
                </tr>
            </table>

            <table class="checklist">
                <tr class="line" v-for="(item, indexField) in content.data.checkListField.length / 2" :key="indexField">
                    <td width="17%">
                        {{ content.data.checkListField[indexField].name }}
                    </td>
                    <td width="33%">
                        <div class="checkbox-group" v-for="(input, indexInput) in content.data.checkListField[indexField].checkBox" :key="indexInput">
                            <span class="checkbox"><span :class="{ 'checked': getCheckListTickBox(content.data.checkListField[indexField].group, content.data.checkListField[indexField].checkBox[indexInput].property) }">x</span></span>
                            <label>{{ content.data.checkListField[indexField].checkBox[indexInput].name }}</label>
                        </div>
                    </td>
                    <td width="17%">
                        {{ content.data.checkListField[(content.data.checkListField.length / 2) + indexField].name }}
                    </td>
                    <td width="33%">
                        <div class="checkbox-group" v-for="(input, indexInput) in content.data.checkListField[(content.data.checkListField.length / 2) + indexField].checkBox" :key="indexInput">
                            <span class="checkbox"><span :class="{ 'checked': getCheckListTickBox(content.data.checkListField[(content.data.checkListField.length / 2) + indexField].group, content.data.checkListField[(content.data.checkListField.length / 2) + indexField].checkBox[indexInput].property) }">x</span></span>
                            <label>{{ content.data.checkListField[(content.data.checkListField.length / 2) + indexField].checkBox[indexInput].name }}</label>
                        </div>
                    </td>
                </tr>
            </table>

            <div class="remark">
                <strong>รายละเอียดอื่นๆ</strong> {{ content.data.detail }}
            </div>

            <div class="remark">
                <strong>หมายเหตุ</strong> {{ content.store.remark.inspection }}
            </div>

            <div class="signature">
                <div class="col space"></div>
                <div class="col license">
                    <div class="line"></div>
                    <div class="date">&nbsp;</div>
                    <label>ผู้ตรวจเช็ค</label>
                </div>
                <div class="col space"></div>
                <div class="col license">
                    <div class="line"></div>
                    <div class="date">&nbsp;</div>
                    <label>ผู้เข้ารับบริการ</label>
                </div>
                <div class="col space"></div>
            </div>
        </section>
    </div>
</template>

<script>
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';

export default {
    data() {
        return {
            content: null,
            paperStyle: '',
            localStyle: `
                .paper {
                    margin: 10px auto;
                }
                .paper .header {
                    margin: 0;
                }
                .paper .bill-no {
                    font-size: 12px;
                    margin: 10px 0;
                }
                .paper .document-data {
                    margin: 10px 0;
                }
                .paper .document-data .left {
                    float: left;
                    width: 40%
                }
                .paper .document-data .right {
                    float: right;
                    text-align: right;
                    width: 40%
                }
                .paper table th {
                    padding: 5px;
                }
                .paper table td {
                    vertical-align: middle;
                    padding: 3px;
                }
                .paper table.checklist {
                    margin-top: 15px;
                }
                .paper .checkbox-group {
                    vertical-align: baseline;
                }
                .paper .checkbox-group .checkbox {
                    vertical-align: baseline;
                }
                .paper .checkbox-group .checkbox span {
                    color: #fff;
                }
                .paper .checkbox-group .checkbox span.checked {
                    color: #000;
                }
                .paper .remark {
                    margin-top: 15px;
                }
                .paper .signature {
                    margin-top: 40px;
                    overflow: hidden;
                }
            `,
            checkList: []
        }
    },
    props: {
        fields: Object,
        globalStyle: String
    },
    watch: {
        fields(value) {
            this.content = value;
        }
    },
    mounted() {
        this.setupPaperStyle();
    },
    methods: {
        setupPaperStyle() {
            this.paperStyle = [ '<style>', this.globalStyle, this.localStyle, '</style>' ].join('');
        },
        getCustomerName() {
            let customerName = '';

            if (this.content.data.jobType === this.$Constants.JOB_FORM_STORE) {
                customerName = [ 'ชื่อร้านค้า', this.content.data.customerStore.name ].join(' ');
            } else if (this.content.data.jobType === this.$Constants.JOB_FORM_FLEET) {
                customerName = ['ชื่อบริษัท ', this.content.data.fleet.company ].join(' ');
            } else {
                customerName = ['ชื่อลูกค้า ', this.content.data.customer.customerFirstName, this.content.data.customer.customerLastName ].join(' ');
            }

            return customerName;
        },
        getTelData() {
            if (this.content.data.jobType === this.$Constants.JOB_FORM_STORE) {
                return this.content.data.customerStore.contactTel;
            } else if (this.content.data.jobType === this.$Constants.JOB_FORM_FLEET) {
                return this.content.data.fleet.contactTel;
            } else {
                return this.content.data.customer.customerTel;
            }
        },
        getCarData() {
            return [ this.content.data.customer.carBrand, this.content.data.customer.carModel, this.content.data.customer.carYearSerie ].filter(Boolean).join(' ');
        },
        getLicensePlateData() {
            return [ this.content.data.customer.licensePlate, ' (' + OptionLicensePlateProvince.service.getValueByKey(this.content.data.customer.licensePlateProvince) + ')'].join(' ');
        },
        getCheckListTickBox(group, property) {
            return this.content.data.checkList[group].checkGroup[property];
        }
    }
}
</script>